import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FaBars,
  FaChartPie,
  FaUsers,
  FaBell,
  FaCogs,
  FaStar,
  FaChevronDown,
  FaChartBar,
  FaClipboardList,
  FaSignOutAlt,
  FaHome
} from "react-icons/fa";

import "./AdminNavbar.css";

const AdminNavbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [frontendOpen, setFrontendOpen] = useState(false);
  const [scrollDirection, setScrollDirection] = useState("up");

  const navigate = useNavigate();

  // Hide on scroll down / show on scroll up
  useEffect(() => {
    let lastScroll = window.scrollY;

    const handleScroll = () => {
      const current = window.scrollY;
      setScrollDirection(current > lastScroll ? "down" : "up");
      lastScroll = current;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("adminTokenLoo");
    localStorage.removeItem("adminUserLoo");
    navigate("/admin");
  };

  return (
    <nav className={`admin-navbar ${scrollDirection === "down" ? "hide" : "show"}`}>
      <div className="nav-container">

        {/* LOGO LEFT SIDE */}
        <div className="logo-section">
          <img
            src="/Images/icon tm.png"
            alt="Varankal Logo"
            className="logo-img1"
          />
          {/* <h2 className="logo-title">Admin</h2> */}
        </div>

        {/* MOBILE MENU TOGGLE */}
        <button className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
          <FaBars />
        </button>

        {/* NAV LINKS */}
        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>

          <li><NavLink to="/admin/dashboard"><FaChartPie /> Dashboard</NavLink></li>
          <li><NavLink to="/admin/usermanagement"><FaUsers /> Users</NavLink></li>
          <li><NavLink to="/admin/view"><FaStar /> Plans</NavLink></li>
          <li><NavLink to="/admin/notification"><FaBell /> Alerts</NavLink></li>

          {/* Reports */}
          <li className="dropdown">
            <button className="dropdown-btn">
              <FaChartBar /> Reports <FaChevronDown />
            </button>

            <ul className="dropdown-menu">
              <li><NavLink to="/admin/report"><FaChartBar /> Main</NavLink></li>
              <li><NavLink to="/admin/overallusersreports"><FaClipboardList /> Users</NavLink></li>
              <li><NavLink to="/admin/userplans"><FaClipboardList /> Plans</NavLink></li>
            </ul>
          </li>

          {/* Settings */}
          <li className="dropdown">
            <button className="dropdown-btn" onClick={() => setSettingsOpen(!settingsOpen)}>
              <FaCogs /> Settings <FaChevronDown />
            </button>

            {settingsOpen && (
              <ul className="dropdown-menu">

                <li><NavLink to="/admin/systemsettings"><FaCogs /> System</NavLink></li>
                <li><NavLink to="/admin/emailsms"><FaClipboardList /> Email</NavLink></li>

                {/* Frontend Submenu */}
                <li className="dropdown-sub">
                  <button onClick={() => setFrontendOpen(!frontendOpen)}>
                    <FaHome /> Frontend <FaChevronDown />
                  </button>

                  {frontendOpen && (
                    <ul className="dropdown-submenu">
                      <li><NavLink to="/admin/home"><FaHome /> Home</NavLink></li>
                      <li><NavLink to="/admin/blogs"><FaUsers /> Blogs</NavLink></li>
                      <li><NavLink to="/admin/review"><FaStar /> Reviews</NavLink></li>
                      <li><NavLink to="/admin/about"><FaStar /> About</NavLink></li>
                      <li><NavLink to="/admin/plans"><FaStar /> Plans </NavLink></li>
                    </ul>
                  )}
                </li>
              </ul>
            )}
          </li>

          <button className="logout-btn" onClick={handleLogout}>
            <FaSignOutAlt /> Logout
          </button>

        </ul>
      </div>
    </nav>
  );
};

export default AdminNavbar;
